import { useSelector } from "react-redux";
import { StoreProptypes } from "../../PropTypes/StoreProptypes";
import { useTranslation } from "react-i18next";
import DashboardPagesTemplate from "../../Template/DashboardPagesTemplate";
import DashboardPageTitle from "../../Components/InnerPageTitle";
import { Form, InputGroup } from "react-bootstrap";
import "../../Assets/scss/pages/website-list.scss";
import CopyWidgetScriptCode from "../../Components/ScriptCode";
import React, { useEffect, useRef, useState } from "react";
import DateRangeFilterBlock from "../../Components/DateRangeFilterBlock";
import useWindowScroll from "../../Helpers/useWindowScroll";
import NoRecordFound from "../../Components/NoRecordFound";
import ShowRecordItem from "../../Components/ShowRecordItem";
import PaginationComponent from "../../Components/Pagination";
import { useDispatch } from "react-redux";
import { getUserActivityListService } from "../../Services/UserActivityService";
import { UserActivityPropTypes } from "../../PropTypes/UserPropTypes";
import parseISODate from "../../Helpers/parseISODate";

// component to display user activity
const UserActivityPage = () => {

    const [totalRecord, setTotalRecord] = useState<number>(0);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [limit, setLimit] = useState<number>(10);
    const [offset, setOffset] = useState<number>(0);
    const [startDate, setStartDate] = useState<string>(``);
    const [endDate, setEndDate] = useState<string>(``);
    const prevLimitRef = useRef<number>(10);
    const [userActivityList, setUserActivityList] = useState<UserActivityPropTypes[]>([]);
    // Redux Data
    const { currentWebsite, user, accessToken } = useSelector((store: StoreProptypes) => store);

    const dispatch = useDispatch();

    const windowScrollValue = useWindowScroll('aioa_dashboard-website-list-filter');

    // Functions
    const { t } = useTranslation();

    useEffect(() => {
      setCurrentPage(1);
    }, [limit]);
  
    useEffect(() => {
      setOffset(currentPage * limit - limit);
    }, [currentPage, limit]);
  
    useEffect(() => {
      // check if access token is available, limit and domain search is not changed
      if (accessToken && ((limit === prevLimitRef.current))) {
        // service to get user activity list with filters
        getUserActivityListService(accessToken, dispatch, t, setUserActivityList, limit, offset, startDate, endDate, setTotalRecord);
      }
    }, [offset, user, startDate, endDate]);
  
    useEffect(() => {
      // check if limit is changed, or domain search is changed; and offset is set to 0
      if ((limit !== prevLimitRef.current)) {
        // check if access token exists
        if (accessToken) {
          // service to get user activity list with filters
          getUserActivityListService(accessToken, dispatch, t,setUserActivityList, limit, offset, startDate, endDate, setTotalRecord);
        }
  
        prevLimitRef.current = limit;
      }
    }, [offset, limit]);

  return (
    <>
      <DashboardPagesTemplate>

        <DashboardPageTitle
          pageTitle={`${t("User Activity")}`}
        />

        <div className="aioa_dashboard-website-list">
            <div className={`aioa_dashboard-website-list-filter-wrapper ${windowScrollValue}`} id="aioa_dashboard-website-list-filter">

            {user && user.department === 1 && (
                <>
                <div className="aioa_dashboard-website-list-filter-block">
                    <DateRangeFilterBlock
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                    isSetDefaultValue={2}
                    />
                </div>
                </>
            )}

            <div className="aioa_dashboard-website-list-filter-block">
                <Form.Label htmlFor='showPages'>{t("Items Per Page")}</Form.Label>
                <Form.Select
                onChange={(e) => setLimit(parseInt(e.target.value))}
                id="showPages"
                value={limit}
                aria-label={t("Items Per Page").toString()}
                >
                <option value="10">{t("10")}</option>
                <option value="20">{t("20")}</option>
                <option value="40">{t("40")}</option>
                <option value="80">{t("80")}</option>
                <option value="100">{t("100")}</option>
                </Form.Select>
            </div>

            </div>

            <div className="aioa_dashboard-table">

            <div className="aioa_dashboard-table-thead">
                <div className="aioa_dashboard-table-tr">
                <div className="aioa_dashboard-table-th tcw-100 text-left aioa_dashboard-table-cell-sidegap">{t("Sr No")}</div>
                {(user?.department === 1 || (user?.parent_id === 0 || user?.parent_id === 1)) && (
                  <div className="aioa_dashboard-table-th tcw-250 aioa_dashboard-table-cell-sidegap">{t("User")}</div>
                )}
                <div className="aioa_dashboard-table-th tcw-200 aioa_dashboard-table-cell-sidegap">{t("IP Address")}</div>
                <div className="aioa_dashboard-table-th tcw-300 aioa_dashboard-table-cell-sidegap">{t("Description")}</div>
                <div className="aioa_dashboard-table-th tcw-200 aioa_dashboard-table-cell-sidegap">{t("Action")}</div>
                <div className="aioa_dashboard-table-th tcw-250 aioa_dashboard-table-cell-sidegap">{t("Date & Time")}</div>
                </div>
            </div>

            <div className="aioa_dashboard-table-body" aria-live='polite'>

                {userActivityList ? (
                <>
                    {userActivityList.length > 0 ? (
                    <>
                            {userActivityList.map((item, index) => {
                            return (
                              <React.Fragment key={item.id}>
                                <div className={`aioa_dashboard-table-tr`}>
                                <div className="aioa_dashboard-table-td tcw-100 aioa_dashboard-table-cell-sidegap">
                                    <div className='aioa_dashboard-table-td-cell-title d-xl-none' aria-hidden="true">{t("Sr No")}</div>
                                    <div className='aioa_dashboard-table-td-cell-value' aria-label={t("Sr No").toString()}><div className='email-filed'>{item.sr_no}</div></div>
                                </div>
                                  {(user?.department === 1 || (user?.parent_id === 0 || user?.parent_id === 1)) && (
                                    <div className="aioa_dashboard-table-td tcw-250 aioa_dashboard-table-cell-sidegap">
                                        <div className='aioa_dashboard-table-td-cell-title d-xl-none' aria-hidden="true">{t("User")}</div>
                                        <div className='aioa_dashboard-table-td-cell-value' aria-label={t("User").toString()}>
                                            <div className='email-filed'><span>{item.name}</span><br />{item.email} </div>
                                        </div>
                                    </div>
                                  )}
                                <div className="aioa_dashboard-table-td tcw-200 aioa_dashboard-table-cell-sidegap">
                                    <div className='aioa_dashboard-table-td-cell-title d-xl-none' aria-hidden="true">{t("IP Address")}</div>
                                    <div className='aioa_dashboard-table-td-cell-value' aria-label={t("IP Address").toString()}>
                                        <div className='email-filed'>{item.ip_address}</div>
                                    </div>
                                </div>
                                <div className="aioa_dashboard-table-td tcw-300 aioa_dashboard-table-cell-sidegap">
                                    <div className='aioa_dashboard-table-td-cell-title d-xl-none' aria-hidden="true">{t("Description")}</div>
                                    <div className='aioa_dashboard-table-td-cell-value' aria-label={t("Description").toString()}>
                                        <div className='email-filed'>{item.description}</div>
                                    </div>
                                </div>
                                <div className="aioa_dashboard-table-td tcw-200 aioa_dashboard-table-cell-sidegap">
                                    <div className='aioa_dashboard-table-td-cell-title d-xl-none' aria-hidden="true">{t("Action")}</div>
                                    <div className='aioa_dashboard-table-td-cell-value' aria-label={t("Action").toString()}>
                                        <div className='email-filed'>{item.action_type}</div>
                                    </div>
                                </div>
                                <div className="aioa_dashboard-table-td tcw-250 aioa_dashboard-table-cell-sidegap">
                                    <div className='aioa_dashboard-table-td-cell-title d-xl-none' aria-hidden="true">{t("Timestamp")}</div>
                                    <div className='aioa_dashboard-table-td-cell-value' aria-label={t("Timestamp").toString()}>
                                        <div className='email-filed'>{parseISODate(item.created_at, false, false, true)}</div>
                                    </div>
                                </div>
                              </div>

                                </React.Fragment>
                            )
                            })}
                    </>
                    ) : (
                    <>
                        <NoRecordFound imageType={`page`} noRecordText={`${t('User Activity not found')}.`} />
                    </>
                    )}
                </>
                ) : (
                <>

                </>
                )}

            </div>

            <div className="aioa_dashboard-table-pagination-main">
                <>
                <ShowRecordItem
                    offset={offset}
                    limit={limit}
                    totalRecord={totalRecord}
                />
                <PaginationComponent

                    currentPage={currentPage}
                    totalRecords={totalRecord}
                    itemsPerPage={limit}
                    setCurrentPage={setCurrentPage}
                />
                </>
            </div>

            </div>

        </div>
      </DashboardPagesTemplate>

    </>
  )
}

export default UserActivityPage;
